module.exports = __webpack_public_path__ + "static/media/happy-phone.74212f70.svg";